// Traits currently populated by the Trait GASv3 builder:

// https://data-portal.internal.atlassian.com/targeting/traits/a1b9c7b1-9351-4291-b7f0-06931ddde664
export const TRELLO_JIRA_CONF_CO_USERS = 'trello_jira_conf_co_users';

// https://data-portal.internal.atlassian.com/targeting/traits/a656c646-8fb0-460c-9a3d-5337a09d4f5a
export const ALL_TRELLO_JIRA_CO_USERS = 'all_trello_jira_co_users';

// https://data-portal.internal.atlassian.com/targeting/traits/f52560f9-671d-4e4a-8120-1bd31d3eff04
export const TRELLO_GA_MODAL_DATE = 'trello_ga_modal_date';

// https://data-portal.internal.atlassian.com/targeting/traits/2f54df10-8060-440b-88ca-fd497807edd1
export const TRELLO_UI_BUTTON_CLICKED_ONBOARDINGLISTSPOTLIGHTDONEBUTTON_ONBOARDINGLISTSPOTLIGHT_FIRST_TIME =
  'trello_ui_button_clicked_onboardinglistspotlightdonebutton_onboardinglistspotlight_first_time';

// https://data-portal.internal.atlassian.com/targeting/traits/00c2ee11-511d-4ee0-ba40-d1d8130cd195
export const TRELLO_UI_BUTTON_CLICKED_CONNECTACCOUNTBUTTON_PLANNERSCREEN_CHANGED =
  'trello_ui_button_clicked_connectaccountbutton_plannerscreen_changed';

// https://data-portal.internal.atlassian.com/targeting/traits/38cf4018-8eb8-49b3-b0e2-6c90ddf089f7
export const TRELLO_OPERATIONAL_PLANNERDISCOVERYSPOTLIGHTELIGIBILITY_EXCLUDED_CHANGED =
  'trello_operational_plannerdiscoveryspotlighteligibility_excluded_changed';

// https://data-portal.internal.atlassian.com/targeting/registry/2b4d84c1-0caa-46af-9fca-075b18824f7a
export const SEGMENT_TRELLO_HAS_LEARNED_MORE_INBOX_QUICK_CAPTURE_REAL_TIME_AAID =
  'segment_trello_has_learned_more_inbox_quick_capture_real-time_aaid';

// https://data-portal.internal.atlassian.com/targeting/registry/399ca46e-2335-4f35-aa6b-70a814b2ac30
export const SEGMENT_TRELLO_HAS_USED_INBOX_QUICK_CAPTURE_REAL_TIME_AAID =
  'segment_trello_has_used_inbox_quick_capture_real-time_aaid';

// https://data-portal.internal.atlassian.com/targeting/traits/0842a575-468d-4dca-992d-61c71e7a641a
export const TRELLO_TRACK_CARD_ADDED_QUICK_CAPTURE_CHANGED_BATCH =
  'trello_track_card_added_quick_capture_changed_batch';

// https://data-portal.internal.atlassian.com/targeting/traits/960ae1af-e26d-423a-82e6-dca3c81f99f9
export const TRELLO_UI_CLICKED_QUICK_CAPTURE_PROMPT_CHANGED_BATCH =
  'trello_ui_clicked_quick_capture_prompt_changed_batch';

// https://data-portal.internal.atlassian.com/targeting/traits/7405db5f-8180-41ae-b27b-c28c907a372e
export const TRELLO_OPERATIONAL_QUICK_CAPTURE_DISCOVERY_ENABLED_CHANGED =
  'trello_operational_quick_capture_discovery_enabled_changed';

// https://data-portal.internal.atlassian.com/targeting/registry/51d9da34-54e8-486b-843e-97e1e543f332
export const SEGMENT_TRELLO_HAS_LEARNED_MORE_INBOX_INFO_PANEL_QC_AAID =
  'segment_trello_has_learned_more_inbox_info_panel_qc_aaid';

// https://data-portal.internal.atlassian.com/targeting/traits/7545f420-9c40-49ef-91ea-efb50723f5b8
export const TRELLO_HAS_USED_PAID_PLANNER_ACTIONS_CHANGED =
  'trello_has_used_paid_planner_actions_changed';

// https://data-portal.internal.atlassian.com/targeting/traits/ecd7d2fa-56ab-482c-8b16-b3d0db735efc
export const TRELLO_PLANNER_VIEWED_REAL_TIME_AAID =
  'trello_planner_viewed_real_time_aaid';

// https://data-portal.internal.atlassian.com/targeting/traits/381c0881-04b4-4334-ab7d-85675cbe758a
export const TRELLO_VNEXT_JIRA_CONF_CO_USERS = 'Test_Trello_Jira_Co_Usage';

const TRAIT_NAMES = [
  ALL_TRELLO_JIRA_CO_USERS,
  TRELLO_GA_MODAL_DATE,
  TRELLO_JIRA_CONF_CO_USERS,
  TRELLO_VNEXT_JIRA_CONF_CO_USERS,
  TRELLO_UI_BUTTON_CLICKED_ONBOARDINGLISTSPOTLIGHTDONEBUTTON_ONBOARDINGLISTSPOTLIGHT_FIRST_TIME,
  TRELLO_UI_BUTTON_CLICKED_CONNECTACCOUNTBUTTON_PLANNERSCREEN_CHANGED,
  TRELLO_OPERATIONAL_PLANNERDISCOVERYSPOTLIGHTELIGIBILITY_EXCLUDED_CHANGED,
  SEGMENT_TRELLO_HAS_LEARNED_MORE_INBOX_QUICK_CAPTURE_REAL_TIME_AAID,
  SEGMENT_TRELLO_HAS_USED_INBOX_QUICK_CAPTURE_REAL_TIME_AAID,
  TRELLO_TRACK_CARD_ADDED_QUICK_CAPTURE_CHANGED_BATCH,
  TRELLO_UI_CLICKED_QUICK_CAPTURE_PROMPT_CHANGED_BATCH,
  TRELLO_OPERATIONAL_QUICK_CAPTURE_DISCOVERY_ENABLED_CHANGED,
  SEGMENT_TRELLO_HAS_LEARNED_MORE_INBOX_INFO_PANEL_QC_AAID,
  TRELLO_HAS_USED_PAID_PLANNER_ACTIONS_CHANGED,
  TRELLO_PLANNER_VIEWED_REAL_TIME_AAID,
] as const;

export type TraitName = (typeof TRAIT_NAMES)[number];
export type TraitValue = boolean | number | string;

// Helper function to check if a string is a valid trait name
export const isValidTraitName = (name: string): name is TraitName => {
  return TRAIT_NAMES.includes(name as TraitName);
};

export type Traits = Record<TraitName | string, TraitValue>;
